import { render, staticRenderFns } from "./ServerErrors.vue?vue&type=template&id=514876a7&scoped=true&"
import script from "./ServerErrors.vue?vue&type=script&lang=js&"
export * from "./ServerErrors.vue?vue&type=script&lang=js&"
import style0 from "./ServerErrors.vue?vue&type=style&index=0&id=514876a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514876a7",
  null
  
)

export default component.exports